import { requestHelpers } from '../../../../../helpers';

export const actions = {
    SET_PROFILE_MARKETS: "SET_PROFILE_MARKETS",
    GENERAL_MARKETS_REQUEST: "GENERAL_MARKETS_REQUEST",
    GENERAL_MARKETS_SUCCESS: "GENERAL_MARKETS_SUCCESS",
    GENERAL_MARKETS_ERROR: "GENERAL_MARKETS_ERROR",
}

export const setMarkets = ( profile ) => {
    return {
        type: actions.SET_PROFILE_MARKETS,
        personId: profile.id,
        markets: profile.markets,
    }
}


export const marketsApiCall = ( personId, payload, type ) => {
    const requestType = type === 'CREATE' ? 'POST' : ( type === 'UPDATE' ? 'PUT' : type );

    // return ( dispatch ) => {
    //     dispatch( {
    //         type: actions.GENERAL_MARKETS_REQUEST,
    //         isLoading: true,
    //         isError: false,
    //     })
    //     requestHelpers
    //         .authenticatedPostRequest( `/profiles/${ personId }/markets`, { payload }, requestType )
    //         .then( ( response ) => {
    //             console.log(response)
    //             return dispatch( {
    //                 type: actions.GENERAL_MARKETS_SUCCESS,
    //                 personId: personId,
    //             })
    //         })
    //         .catch( ( error ) => {
    //             return dispatch( {
    //                 type: actions.GENERAL_MARKETS_ERROR,
    //                 isLoading: false,
    //                 isError: true,
    //                 error,
    //             })
    //         })
    // }
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/markets.js